export default function Donate() {
	return (
		<>
			<h1>Donate</h1>
		</>
	);
}